// extracted by mini-css-extract-plugin
export default {"CardStackWrapper":"DropZone_CardStackWrapper__A0S8p","LooserStack":"DropZone_LooserStack__59++Q","DeckStack":"DropZone_DeckStack__pAHqM","Tilty":"DropZone_Tilty__IDSjI"};